import { createAsyncThunk } from '@reduxjs/toolkit';
import type { CustomerTransaction, WLAppExtraArgument, WLRootState } from '@talos/kyoko';
import { DEPOSIT_CANCEL_REQUEST, resetSwapForm, WITHDRAW_CANCEL_REQUEST } from '@talos/kyoko';
import { v4 as uuid } from 'uuid';

type CancelBalanceRequest = Pick<CustomerTransaction, 'TransactionID'>;

export const cancelBalanceTransactionThunk = createAsyncThunk<
  undefined,
  void,
  {
    state: WLRootState;
    extra: WLAppExtraArgument | undefined;
  }
>('swap/cancelBalanceTransactionThunk', async (_arg, { extra, getState, dispatch }) => {
  const wsClient = extra?.wsClient;
  const state = getState();
  if (!wsClient || !state.swap.meta.transactionID) {
    return undefined;
  }

  const clReqId = uuid();

  const request: CancelBalanceRequest = { TransactionID: state.swap.meta.transactionID };
  const requestType = state.swap.mode === 'withdraw' ? WITHDRAW_CANCEL_REQUEST : DEPOSIT_CANCEL_REQUEST;

  wsClient.registerPublication({
    type: requestType,
    data: [
      {
        ClReqID: clReqId,
        TransactionID: request.TransactionID,
      },
    ],
  });
  dispatch(resetSwapForm({ keepFromQty: true }));
});
